module.exports = __webpack_public_path__ + "static/media/191CS213.8c9e5ac4.jpg";